import {
    addToChainAfter,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    DispatchBeginPlaceOrder,
    ExecuteOnSuccessCallback,
    SetCartStatus,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { CustomState } from "@midland-industries/Store/Reducers";
import cloneDeep from "lodash/cloneDeep"

type PlaceOrderProps = Parameters<typeof DispatchBeginPlaceOrder>[0];

function CustomSetCartStatus(props: PlaceOrderProps) {
    const state = props.getState();
    const { cartId } = state.pages.onePageCheckout;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;

    if (!cart) {
        throw new Error("There was no current cart and we are trying to place the current cart as an order.");
    }

    const newStatus = cart?.requiresApproval
        ? "AwaitingApproval"
        : props.parameter?.isPending
        ? "PendingPaymentValidation"
        : "Submitted";

    props.cartToUpdate = {
        ...cloneDeep(cart),
        status: newStatus,
        poNumber: props.parameter.poNumber,
    };
}

function SetPackingBasis(props: PlaceOrderProps) {
    const state = props.getState() as CustomState;
    props.cartToUpdate = {
        ...props.cartToUpdate,
        approverReason: state.customData.checkout.packingBasis,
    };
}

function CustomExecuteOnSuccessCallback(props: PlaceOrderProps) {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult.cart.orderNumber);
}

replaceInChain(chain, ExecuteOnSuccessCallback, CustomExecuteOnSuccessCallback);
addToChainAfter(chain, SetCartStatus, SetPackingBasis);
replaceInChain(chain, SetCartStatus, CustomSetCartStatus);
